import { Controller } from "@hotwired/stimulus"

import { formatElapsed, startFor } from "../lib/elapsed_clock.mjs"

// Counts up every second from the elapsed seconds the server rendered (see
// lib/elapsed_clock.mjs). `key` names the thing being timed, so a re-render of the
// same clock (the reporting chat's polled frame) continues instead of jumping;
// without a key, each clock starts from its own server value.
export default class extends Controller {
  static values = { seconds: Number, key: String }

  connect() {
    this.start = this.keyValue ? startFor(this.keyValue, this.secondsValue) : Date.now() - this.secondsValue * 1000
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  render() {
    this.element.textContent = formatElapsed(this.start)
  }
}
